module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_MotorVoltage_16"],"path":[{"$":{"d":"M14,6V8H13V5H8V4h2V3H4V4H6V5H2V8H1V6H0v5H1V9H2v4H4l2,1h7V11h1v2h2V6ZM5.5,14l2-4h-3l5-5-2,4h3Z"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_MotorVoltage_16.svg
// module id = zJEw
// module chunks = 1